import React, { PureComponent } from "react";
import { message, Tooltip } from "antd";
import { downloadImg } from "@/utils/constant";
import VoltageGauge from "./components/VoltageGauge"
import Temperature from "./components/Temperature"
import CurrentGauge from "./components/CurrentGauge"
import LiquidFill from "./components/LiquidFill";
import PropIcon from "@/components/Icon/PropIcon";
import http from "@/http";
import img1 from "./components/img/信号-优.png"
import img2 from "./components/img/信号-良好.png"
import img3 from "./components/img/信号-一般.png"
import img4 from "./components/img/信号-弱.png"
import img5 from "./components/img/信号-无.png"
import img7 from "./components/img/市电供电.png"
import img8 from "./components/img/电池供电.png"
import img9 from "./components/img/蜂鸣器.png"
import img10 from "./components/img/蜂鸣器-静音.png"
import styles from "./status.module.less"

const HttpDevice = http.tokiot.device;
const titleStyle = {
    backgroundColor: 'rgb(24,144,255)',
    borderBottomRightRadius: '1rem', borderTopRightRadius: '1rem',
    fontSize: '0.18rem', marginTop: '0.08rem', marginBottom: '0.08rem',
    height: '0.3rem', width: '1rem', textAlign: 'center',
    color: `#FFF`,
}
const rsrpLevel = ['无信号', '信号弱', '一般', '良好', '优']
const rsrpLevelImg = [img5, img4, img3, img2, img1]

class StatusTab extends PureComponent {
    state = {
        deviceInfo: {},
        actionMap: {},
    }

    componentDidMount() {
        this.getDeviceInfo();
        this.getActionList();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.refreshKey != this.props.refreshKey) {
            this.getDeviceInfo();
            this.getActionList();
        }
    }

    getActionList = () => {
        const { deviceInfo } = this.props;
        if (deviceInfo && deviceInfo.id && deviceInfo.id.length > 0) {
            HttpDevice.product.action.list({ id: deviceInfo.id }).then((ret) => {
                const actionMap = {}
                ret.map(item => {
                    item.paramList = JSON.parse(item.inputParams);
                    actionMap[item.code] = item;
                    return item;
                })
                this.setState({ actionMap, operationList: ret })
            });
        }
    }

    getDeviceInfo = () => {
        const { deviceInfo } = this.props;
        if (deviceInfo && deviceInfo.id && deviceInfo.id.length > 0) {
            HttpDevice.get({ id: deviceInfo.id, allShadowProp: true }).then(ret => {
                if (ret) {
                    const { shadowProp = [] } = ret
                    const status = {}
                    shadowProp.forEach(item => status[item.code] = item)
                    const fieldList = [
                        'voltageA', 'voltageB', 'voltageC',
                        'currentA', 'currentB', 'currentC',
                        'temp1', 'temp2', 'temp3', 'temp4', 'deviceTemp',
                        'leakage', 'leakage1', 'leakage2'
                    ]
                    const suf = ['Value', 'MaxThr', 'MinThr', 'Status', 'AlarmEnable', 'AlarmSw']

                    const fieldMap = {}
                    let detail = {}
                    fieldList.forEach(field => {
                        fieldMap[field] = {}
                        suf.forEach(suf => {
                            detail = status[field + suf];
                            if (detail) {
                                fieldMap[field][suf] = detail
                            }
                        })
                    })
                    ret.fieldMap = fieldMap
                    ret.status = status
                    this.setState({ deviceInfo: ret });
                } else {
                    this.setState({ deviceInfo: {} });
                }
            });
        }
    }

    onActionSubmit = (data) => {
        const { deviceInfo } = this.state;
        if (deviceInfo && deviceInfo.id && deviceInfo.id.length > 0) {
            HttpDevice.action(data).then(ret => {
                if (ret) {
                    message.success("操作成功");
                    this.getDeviceInfo(data.deviceId);
                } else {
                    message.error(`操作失败`)
                }
            })
        }
    }

    getLastActionParams = (data, resolve) => {
        const { deviceInfo } = this.state;
        if (deviceInfo && deviceInfo.id && deviceInfo.id.length > 0) {
            HttpDevice.getLastActionParams({ ...data, id: deviceInfo.id }).then(ret => resolve(ret));
        }
    }

    render() {
        const { deviceInfo, actionMap } = this.state
        if (!(deviceInfo && deviceInfo.id && deviceInfo.id.length > 0)) return ``;
        const { fieldMap, status } = deviceInfo;
        let detail = deviceInfo;
        const buzzerStatus = status.buzzerStatus || {}
        const powerStatus = status.powerStatus || {}
        const rssi = status.rssi || {}

        const actionProps = {
            defaultValue: status,
            loadDefaultValue: this.getLastActionParams,
            deviceId: detail.id,
            onActionSubmit: this.onActionSubmit,
        }

        return (
            <div className={styles.main}>
                <div style={{ ...titleStyle, backgroundColor: 'rgb(24,144,255)' }}>设备信息</div>
                <div className={styles.deviceInfo}>
                    <Tooltip title={`信号强度`}>
                        {deviceInfoItem({
                            img: rsrpLevelImg[formatRsrp(rssi.defValue)],
                            lable: rsrpLevel[formatRsrp(rssi.defValue)]
                        })}
                    </Tooltip>
                    <Tooltip title={`告警总开关状态`}>
                        {deviceInfoItem({
                            img: buzzerStatus.defValue ? img9 : img10,
                            lable: (buzzerStatus.defValue ? '开' : '关')
                        })}
                    </Tooltip>
                    <Tooltip title={`市电状态`}>
                        {deviceInfoItem({
                            img: 1 == powerStatus.defValue ? img7 : img8,
                            lable: 1 == powerStatus.defValue ? '市电' : '电池'
                        })}
                    </Tooltip>
                </div>
                <div style={{ ...titleStyle, backgroundColor: 'rgb(224,98,13)' }}>剩余电流</div>
                <div className={styles.liquidFillDiv}>
                    <LiquidFill data={fieldMap.leakage2} filed='' action={actionMap.SetLeakage2}   {...actionProps} />
                </div>
                <div style={{ ...titleStyle, backgroundColor: 'rgb(224,98,13)' }}>电流监控</div>
                <div className={styles.group}>
                    <div className={styles.item}>
                        <CurrentGauge data={fieldMap.currentA} filed='A相' action={actionMap.SetCurrentA}  {...actionProps} />
                    </div>
                    <div className={styles.item}>
                        <CurrentGauge data={fieldMap.currentB} filed='B相' action={actionMap.SetCurrentB}{...actionProps} />
                    </div>
                    <div className={styles.item}>
                        <CurrentGauge data={fieldMap.currentC} filed='C相' action={actionMap.SetCurrentC} {...actionProps} />
                    </div>
                </div>
                <div style={{ ...titleStyle, backgroundColor: 'rgb(224,98,13)' }}>电压监控</div>
                <div className={styles.group}>
                    <div className={styles.item}>
                        <VoltageGauge data={fieldMap.voltageA} filed='A相' action={actionMap.SetVoltageA} {...actionProps} />
                    </div>
                    <div className={styles.item}>
                        <VoltageGauge data={fieldMap.voltageB} filed='B相' action={actionMap.SetVoltageB} {...actionProps} />
                    </div>
                    <div className={styles.item}>
                        <VoltageGauge data={fieldMap.voltageC} filed='C相' action={actionMap.SetVoltageC} {...actionProps} />
                    </div>
                </div>
                <div style={{ ...titleStyle, backgroundColor: 'rgb(224,98,13)' }}>温度监控</div>
                <div className={styles.tempGroup}>
                    <div className={styles.item}>
                        <Temperature data={fieldMap.temp1} filed='A相' bgColor='rgb(236,128,141)'
                            action={actionMap.SetTemp1}  {...actionProps} />
                    </div>
                    <div className={styles.item}>
                        <Temperature data={fieldMap.temp2} filed='B相' bgColor='rgb(236,128,141)'
                            action={actionMap.SetTemp2}  {...actionProps} />
                    </div>
                    <div className={styles.item}>
                        <Temperature data={fieldMap.temp3} filed='C相' bgColor='rgb(236,128,141)'
                            action={actionMap.SetTemp3}  {...actionProps} />
                    </div>
                    <div className={styles.item}>
                        <Temperature data={fieldMap.temp4} filed='零线' bgColor='rgb(236,128,141)'
                            action={actionMap.SetTemp4}  {...actionProps} />
                    </div>
                    <div className={styles.item}>
                        <Temperature data={fieldMap.deviceTemp} filed='设备' bgColor='rgb(236,128,141)'
                            action={actionMap.SetDeviceTemp}  {...actionProps} />
                    </div>

                </div>
            </div>
        )
    }

}

export default StatusTab

function deviceInfoItem({ img, lable }) {
    return (
        <div className={styles.imageMain} >
            <div className={styles.imageDiv} >
                <img src={img} className={styles.image} />
            </div>
            <div className={styles.text}>{lable}</div>
        </div>
    )
}

function formatRsrp(rsrp) {
    if (0 < rsrp && rsrp <= 9) return 2;
    else if (9 < rsrp && rsrp <= 19) return 3;
    else if (19 < rsrp) return 4;
    else return 0;
}